// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../rescript/lib/es6/belt_Result.js";
import * as DateTime$Catalyst from "./DateTime.bs.js";
import * as ErrorUtils$Catalyst from "./ErrorUtils.bs.js";

function resolveResult(result, path) {
  if (result.TAG === /* Ok */0) {
    return result._0;
  }
  var error = result._0;
  return ErrorUtils$Catalyst.raiseError(path, error.path + (" " + error.message), JSON.stringify(error.value));
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), (function (prim) {
                return new Date(prim);
              }));
}

function t_encode(date) {
  return DateTime$Catalyst.toString("DD/MM/YYYY HH:mm:ss", date);
}

var DateUtils = {
  t_decode: t_decode,
  t_encode: t_encode
};

export {
  resolveResult ,
  DateUtils ,
  
}
/* DateTime-Catalyst Not a pure module */
